module.exports = __webpack_public_path__ + "img/Logo_UNIACC.34219262.png";